module.exports = global.config = {
  main: {
    // baseUrl: "https://sandboxc.instantcredit.services/aiass/service_redirect/instant-credit-api-server-ms-service/",
    baseUrl: "https://sandboxc.instantcredit.services/aiass/",
    transactionService: "https://sandboxc.instantcredit.services/aiass/service_redirect/transaction-service-svc/",
    // countryService: "https://sandboxc.instantcredit.services/aiass/service_redirect/instant-credit-api-server-ms-service/",
    countryService: "https://sandboxc.instantcredit.services/aiass/service_redirect/addis-country-service-svc/",
    networkProviderService: "https://sandboxc.instantcredit.services/naps/",
    transactionHistoryService: "https://sandboxc.instantcredit.services/aiass/service_redirect/transaction-history-service-svc/",
    transactionCompletionService: "https://sandboxc.instantcredit.services/aiass/service_redirect/transaction-completion-service-svc/",
    blacklistCountryService: "https://sandboxc.instantcredit.services/aiass/service_redirect/blacklisted-country-service-svc/",
    forexService: "https://sandboxc.instantcredit.services/aiass/service_redirect/addis-exchange-rate-service-v2-svc/",
    updateTransactionService: "https://sandboxc.instantcredit.services/aiass/",


    //transactionService: "transaction-service-svc:8080/",
    //countryService: "addis-country-service-svc:8080/",
    //networkProviderService: "network-and-provider-service-svc:8080/",
    //transactionHistoryService: "transaction-history-service-svc:8080/",
    //transactionCompletionService: "transaction-completion-service-svc:8080/",
  },

  // rest of your translation object
  reportservice: {
    //baseUrl: "http://sandboxexp.instantcredit.services/api/report",
    baseUrl: "https://sandboxexp.instantcredit.services/api/report",
    //baseUrl: "https://sandboxc.instantcredit.services/aiass/service_redirect/report-service-svc/api/report",
    toasterLife: 5000,
    windowTimeOut: "6000",
  },

  //Pagination params
  pagination: {
    default_size: 50,
  },

  //USER TYPES OF INSTA CREDIT
  IC_ADMIN: "0",
  IC_ADMIN_USER: "1",
  IC_FINANCE_ADMIN: "101",
  IC_FINANCE_USER: "102",
  IC_HELPDESK_ADMIN: "201",
  IC_HELPDESK_USER: "202",
  IC_INST_ADMIN: "301",
  IC_INST_ADMIN_ADMIN: "302",
  IC_INST_USER: "303",
};